import { message } from "antd";
import { t } from "i18next";

type ErrorMessageOptions = Record<string, string>;

export enum ClipErrorCode {
  RATE_LIMIT_EXCEEDED = "RATE_LIMIT_EXCEEDED",
  KALODATA_UNSUPPORTED_LINK = "KALODATA_UNSUPPORTED_LINK",
  UNSUPPORTED_COUNTRY = "UNSUPPORTED_COUNTRY",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  DISPOSABLE_EMAIL_BLOCKED = "DISPOSABLE_EMAIL_BLOCKED",
  // 这个错误码还未定义错误文案提示，先暂时不处理，用后端的错误提示
  INSUFFICIENT_BENEFIT = "INSUFFICIENT_BENEFIT",
  ASSET_STORAGE_QUOTA_EXCEEDED = "ASSET_STORAGE_QUOTA_EXCEEDED",
}

export const ErrorCodeMessage: Record<string, string> = {
  [ClipErrorCode.RATE_LIMIT_EXCEEDED]: "You're moving too fast! Please wait a moment and try again.",
  [ClipErrorCode.UNSUPPORTED_COUNTRY]: "This country is not supported.",
  [ClipErrorCode.INTERNAL_ERROR]: "Something went wrong. Please try again.",
  [ClipErrorCode.DISPOSABLE_EMAIL_BLOCKED]: "This email is not supported. Contact [kaloclip@kalowave.com] for help.",
  [ClipErrorCode.ASSET_STORAGE_QUOTA_EXCEEDED]:
    "Storage full ({{storage}}). Please go to the Library to delete some videos or images, empty the trash, and try again.",
};

export const ErrorCodeMessageOptions: Partial<Record<ClipErrorCode, ErrorMessageOptions>> = {
  [ClipErrorCode.ASSET_STORAGE_QUOTA_EXCEEDED]: {
    storage: "500M",
  },
};

export const getErrorMessage = (errorCode: ClipErrorCode) => {
  return ErrorCodeMessage[errorCode];
};

export const getErrorMessageWithOptions = (errorCode: ClipErrorCode) => {
  const text = getErrorMessage(errorCode);
  if (!text) return null;

  return {
    message: text,
    options: ErrorCodeMessageOptions[errorCode],
  };
};

export const processErrorMessage = (error: any) => {
  if (error?.code) {
    const errorMessage = getErrorMessageWithOptions(error.code);
    if (errorMessage) {
      message.error(t(errorMessage.message, errorMessage.options));
      return true;
    }
  }
  return false;
};
